import { OChainId, TChainId } from 'modules/api/chainIDs';
import { SUPPORTED_CHAINS } from '../const';
import { ETH_NETWORK_BY_ENV } from 'modules/api/const';

const defaultChain: TChainId = ETH_NETWORK_BY_ENV;

export function getValidChain(chainId?: number): TChainId {
  if (!chainId) {
    return defaultChain;
  }

  const chain = chainId as TChainId;
  return SUPPORTED_CHAINS.includes(chain) ? chain : OChainId.ethereum;
}
